const getEnv = (envName) => window.env[envName];
export default getEnv;
